import ReactDOM from "react-dom";
import React, { useEffect, useState } from 'react'
import fr1 from '../assets/images/fr1.webp'
import fr2 from '../assets/images/fr2.webp'
import fr3 from '../assets/images/fr3.webp'
import fr4 from '../assets/images/fr4.webp'
import life from '../assets/images/lice.webp'
import Accordion from "react-bootstrap/Accordion";
import plus from "../assets/images/plus.webp";
import langData from '../locales/langData.json'
import CareerForm from '../components/Forms/CareersForm'
import WorkWithUsForm from '../components/Forms/WorkWithUsForm'
import arrow from '../assets/images/right-arrow.webp'
import SEO from '../components/SEO'
import { LazyLoadImage } from 'react-lazy-load-image-component'


const Careers = ({ language }) => {
    const [activeKey, setActiveKey] = useState("0");
    const [showModal, setShowModal] = useState(false);
  
    const careers = langData[language].careers;
   
 
;

    const handleToggle = (key) => {
        setActiveKey(activeKey === key ? null : key);
    };




    // ✅ Prevent background scroll when modal is open
    useEffect(() => {
        if (showModal) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }
        return () => {
            document.body.style.overflow = "";
        };
    }, [showModal]);
    return (
        <>
            <SEO
                title="Careers at CaptainX | Join Our AI Sports Tech Revolution"
                titleAr="وظائف في كابتن اكس | انضم إلى ثورة تكنولوجيا الرياضة"
                description="Build your legacy in sports tech with CaptainX. Explore careers where sports, technology, and purpose unite under Saudi Vision 2030."
                descriptionAr="ابنِ إرثك في مجال التكنولوجيا الرياضية. استكشف مسارات مهنية تجمع بين الرياضة والتكنولوجيا والهدف في إطار رؤية السعودية 2030."
                path="/careers"
                language={language}
            />

            {showModal &&
                ReactDOM.createPortal(
                    <WorkWithUsForm onClose={() => setShowModal(false)} />,
                    document.body
                )
            }
            {showModal &&
                ReactDOM.createPortal(
                    <CareerForm onClose={() => setShowModal(false)}  language={language}/>,
                    document.body
                )
            }

            <section className='careers'>
                <div className="container">
                    <div className="anim-containers d-none d-md-block">
                        <LazyLoadImage src={fr1} alt="fr1" className='im-1' />
                        <LazyLoadImage src={fr2} alt="fr2" className='im-2' />
                        <LazyLoadImage src={fr3} alt="fr3" className='im-3' />
                        <LazyLoadImage src={fr4} alt="fr4" className='im-4' />
                    </div>
                </div>
                <div className="cen-sec-con">

                    <center>
                        <h2
                            className='sec-title career-title'
                            dangerouslySetInnerHTML={{ __html: careers.careertitle }}></h2>
                    </center>
                </div>

                <button
                    className={`explore-btn cta-btn my-4 py-2 gap-3 block-view ${language === "ar" ? "ar-padding" : "en-padding"
                        }`}
                    onClick={() => setShowModal(true)}
                >{careers.careerBtn}

                    <LazyLoadImage src={arrow} alt="arrow" className="rt-btn" />
                </button>
                {/* <p className='sec-p'>{careers.desc}</p> */}

                <div className="marquees mobile-marquee d-block d-md-none">
                    <div className="marquee-content marks marq-img-wrapper mb-3">
                        <LazyLoadImage src={fr1} alt="fr1" />
                        <LazyLoadImage src={fr2} alt="fr2" />
                        <LazyLoadImage src={fr3} alt="fr3" />
                        <LazyLoadImage src={fr4} alt="fr4" />
                        {/* Duplicate for continuous effect */}
                        <LazyLoadImage src={fr1} alt="fr1" />
                        <LazyLoadImage src={fr2} alt="fr2" />
                        <LazyLoadImage src={fr3} alt="fr3" />
                        <LazyLoadImage src={fr4} alt="fr4" />

                    </div>
                </div>
            </section>
            <section className='life'>
                <div className="container">
                    <div className="cen-sec-con">
                        <center>
                            <h2 className="sec-title block-view">
                                {careers.lifetitle}
                            </h2>
                            <p className="sec-p block-view">
                                {careers.lifedesc}
                            </p>
                        </center>
                    </div>
                    <div className="img-bot-con">
                        <LazyLoadImage src={life} alt="life" className='img-fluid' />


                        <div className="container-box-bot">
                            <h6 className=''>{careers.bottitle}</h6>
                            <p className="">
                                {careers.botdesc}
                            </p>
                        </div>

                    </div>
                </div>
            </section>
            <section className='current-opening-sec'>
                <div className="container">
                    <div className="row">

                        <div className="text-align-left col-md-6">
                            <h2 className='sec-title'>{careers.openingtitle}</h2>
                            <p className="sec-p">{careers.openingdesc}  </p>
                        </div>
                        <div className="col-md-6"></div>
                    </div>

                    <Accordion activeKey={activeKey} className="faq-accordion">
                        {careers.openingaccord.map((item, index) => (
                            <Accordion.Item
                                eventKey={index.toString()}
                                key={index}
                                className="faq-item block-view"
                            >
                                <Accordion.Header
                                    onClick={() => handleToggle(index.toString())}
                                    className={`faq-header ${activeKey === index.toString() ? "active" : ""
                                        }`}
                                >
                                    <span className="faq-title">{item.title}</span>
                                    <span
                                        className={`faq-icon ${activeKey === index.toString() ? "active" : ""}`}
                                        style={{
                                            right: language === "ar" ? "90%" : "0",
                                            transition: "0.3s ease"
                                        }}
                                    >
                                        <LazyLoadImage src={plus} alt="toggle" className="plus-icon" />
                                    </span>

                                </Accordion.Header>

                                <Accordion.Body className="faq-body">
                                    <p>{item.desc}</p>
                                    {item.lists && (
                                        <ul>
                                            {item.lists.map((point, i) => (
                                                <li key={i}>{point.list}</li>
                                            ))}
                                        </ul>
                                    )}

                                    <button className='accord-in-btn' onClick={() => setShowModal(true)}>{item.btn}</button>
                                </Accordion.Body>
                            </Accordion.Item>
                        ))}
                    </Accordion>
                </div>
            </section>
            <section className='opening-form'>
                <div className="container">
                    <div className="cen-sec-con my-5">
                        <center>
                            <h2 className="sec-title">
                                {careers.openingtitle2}
                            </h2>
                            <p className="sec-p">
                                {careers.openingdesc2}
                            </p>

                            <button
                                className={`explore-btn cta-btn my-4 py-2 gap-3 block-view ${language === 'ar' ? 'ar-padding' : 'en-padding'
                                    }`}
                                onClick={() => setShowModal(true)}
                            >
                                {careers.openingbtn2}
                                <LazyLoadImage src={arrow} alt="arrow" className="rt-btn" />
                            </button>
                        </center>
                    </div>
                </div>
            </section>

     

        </>
    )
}

export default Careers